const cacherSession = {
    state: {},
    store: (name, state) => {
        sessionStorage.setItem(name, JSON.stringify(state))
    },
    retrieve: (name) => {
        return JSON.parse(sessionStorage.getItem(name))
    },
    check: (name) => {
        return sessionStorage.hasOwnProperty(name)
    }
}

export { cacherSession as default }